///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Route } from '@angular/router';

import { PasswordComponent } from './password.component';
import { UserAuthorities } from '../../services/user/user-authorities';
import { canActivateUser } from '../../shared/auth/user-route-access-service';

export const passwordRoute: Route = {
    path: 'password',
    component: PasswordComponent,
    data: {
        authorities: UserAuthorities.ALL,
        pageTitle: 'global.menu.account.password'
    },
    canActivate: [canActivateUser],
    title: 'Password'
};
